const PGAdapter = require('../../common/pg-adapter')

const STOCK_TRANSACTION_COLUMNS = [
  'id',
  'source',
  'type',
  'request_id',
  'origin',
  'origin_zone',
  'destination',
  'destination_zone',
  'sku',
  'batch',
  'quantity',
  'reason',
  'payload',
  'created_at',
  'created_by',
  'updated_at',
  'updated_by'
]

class StockTransactionsPgAdapter extends PGAdapter {
  constructor (pgConnection, username, logger) {
    super(
      pgConnection,
      'avocado.stock_transactions',
      username,
      STOCK_TRANSACTION_COLUMNS,
      'id',
      {},
      logger,
      { addUuid: true }
    )
  }

  async bulkInsert (rows, { client } = {}) {
    if (!Array.isArray(rows) || rows.length === 0) return []
    return this.bulkCreate(rows, { client })
  }
}

module.exports = StockTransactionsPgAdapter
